// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__FE6Kx","log":"ModalInventoryLogs_log__BScWI","date":"ModalInventoryLogs_date__3MOEx","userName":"ModalInventoryLogs_userName__2w_kD"};